import React, { useRef, useMemo } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Line } from "@react-three/drei";

// Function to generate random positions for nodes
const generateNodes = (count) => {
  return new Float32Array(count * 3).map(() => (Math.random() - 0.5) * 20);
};

// Nodes and Connections Component
const Network = ({ nodeCount = 100 }) => {
  const pointsRef = useRef();
  const nodes = useMemo(() => generateNodes(nodeCount), [nodeCount]);

  useFrame(({ clock }) => {
    // Animate the points for subtle movement
    const time = clock.getElapsedTime();
    if (pointsRef.current) {
      for (let i = 0; i < nodes.length; i += 3) {
        nodes[i + 1] = Math.sin(time + nodes[i]) * 0.5; // Subtle wave animation
      }
      pointsRef.current.geometry.attributes.position.needsUpdate = true;
    }
  });

  return (
    <>
      {/* Nodes */}
      <points ref={pointsRef}>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            array={nodes}
            itemSize={3}
            count={nodes.length / 3}
          />
        </bufferGeometry>
        <pointsMaterial color="#D4AF37" size={0.2} /> {/* Correct material */}
      </points>

      {/* Dynamic Lines (Connections) */}
      {Array.from({ length: nodeCount / 2 }, (_, i) => (
        <Line
          key={i}
          points={[
            [nodes[i * 3], nodes[i * 3 + 1], nodes[i * 3 + 2]],
            [
              nodes[(i + 1) * 3],
              nodes[(i + 1) * 3 + 1],
              nodes[(i + 1) * 3 + 2],
            ],
          ]}
          color="#D4AF37"
          lineWidth={0.5}
        />
      ))}
    </>
  );
};

// Main Background Component
const Background = () => {
  return (
    <Canvas
      camera={{ position: [0, 0, 15], fov: 75 }}
      style={{ position: "absolute", top: 0, left: 0, zIndex: -1 }}
      gl={{ alpha: true }}
    >
      <ambientLight intensity={0.5} />
      <Network nodeCount={150} />
    </Canvas>
  );
};

export default Background;
